
















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import { LicenseModel } from "../models";
import LiteModules from "../components/LiteModules.vue";
import CompleteModules from "../components/CompleteModules.vue";
import ALaCarteModules from "../components/ALaCarteModules.vue";
import Stats from "../components/Stats.vue";
import FinancialModules from "../components/FinancialModules.vue";

const clStore = namespace("compendalicense");
const snackStore = namespace("snackbar");

@Component({
  components: {
    LiteModules,
    CompleteModules,
    ALaCarteModules,
    Stats,
    FinancialModules
  }
})
export default class MyLicense extends Vue {
  @clStore.Getter currentLicense!: LicenseModel;

  @clStore.Action fetchCurrentLicense!: () => Promise<void>;

  @snackStore.Mutation defaultError!: () => void;

  mounted() {
    this.fetchCurrentLicense().catch(() => {
      this.defaultError();
    });
  }
}
